import axios from 'axios'

const API_BASE = '/api/mail-sms/unified'

export default {
  getUnifiedList(params) {
    // 日付をフォーマット
    if (params.date_from instanceof Date) {
      params.date_from = params.date_from.toISOString().split('T')[0]
    }
    if (params.date_to instanceof Date) {
      params.date_to = params.date_to.toISOString().split('T')[0]
    }
    
    return axios.get(`${API_BASE}/`, { params })
  },
  
  getDetail(unifiedId) {
    return axios.get(`${API_BASE}/${unifiedId}/`)
  },
  
  stopMail(unifiedId) {
    return axios.post(`${API_BASE}/${unifiedId}/stop/`)
  },
  
  resendMail(unifiedId) {
    return axios.post(`${API_BASE}/${unifiedId}/resend/`)
  },
  
  exportData(params) {
    return axios.get(`${API_BASE}/export/`, { 
      params,
      responseType: 'blob'
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/mailsms.js